import { useTranslation } from "react-i18next";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { CopyToClipboardCard } from "@/components/ui/copy-to-clipboard-card";
import { Skeleton } from "@/components/ui/skeleton";
import { Switch } from "@/components/ui/switch";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

type Props = {
  emailForwardingId: string;
  isActive: boolean;
  email: string;
  hideToggle?: boolean;
  onDeleteEmailForwarding: (emailForwardingId: string) => Promise<void>;
  onUpdateEmailForwarding: ({
    emailForwardingId,
    alias,
    description,
    isActive,
  }: {
    emailForwardingId: string;
    alias?: string;
    description?: string;
    isActive?: boolean;
  }) => Promise<void>;
};

export const EmailIntegrationCard = ({
  emailForwardingId,
  isActive,
  email,
  onDeleteEmailForwarding,
  onUpdateEmailForwarding,
  hideToggle = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <CopyToClipboardCard
      label={t("forwarding.email.forwarding_address")}
      value={email}
      disabled={!isActive}
    />
  );
};

export const EmailIntegrationCardSkeleton = () => {
  return (
    <div className="rounded-lg border border-gray-200 bg-white overflow-hidden shadow-sm">
      <div className="p-4 space-y-4">
        <div className="flex items-center justify-between">
          <Skeleton className="h-4 w-48" />
          <div className="flex items-center justify-end gap-2">
            <Skeleton className="h-6 w-10 rounded-full" />
            <Skeleton className="h-8 w-8 rounded-md" />
          </div>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="flex items-center justify-between p-3 border rounded-md bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700">
              <Skeleton className="h-6 w-64" />
              <div className="flex items-center gap-1">
                <Skeleton className="h-8 w-8 rounded-md" />
                <Skeleton className="h-8 w-20 rounded-md" />
              </div>
            </div>
          </div>
        </div>
        <Skeleton className="h-4 w-full" />
      </div>
    </div>
  );
};
